/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { useDropzone } from 'react-dropzone';
import { HashLink as Link } from 'react-router-hash-link';
import { toast, ToastContainer } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ContentHeader from 'components/ContentHeader';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import 'react-toastify/dist/ReactToastify.css';

import { storageKeys } from 'settings';

const BookingForm = (props) => {
  const [showIframe, setShowIframe] = useState(false);
  const [agentFirstName, setAgentFirstName] = useState('');
  const [agentLastName, setAgentLastName] = useState('');
  const [agentCompany, setAgentCompany] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [agentCity, setAgentCity] = useState('');
  const [agentCountry, setAgentCountry] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [fileUrl, setFileUrl] = useState(null);

  const DropZone = () => {
    const onDrop = useCallback((acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onload = () => {
          const binaryStr = reader.result;

          // Check file size max 100mb
          if (file.size > 100000000) {
            // Show toast
            toast.error(i18n.translate('rewards.bookingForm.maxSize'), {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            return;
          }

          // Upload file to server and set progress bar
          const data = { name: file.name, type: file.type, size: file.size, url: binaryStr };
          StorageHandler.load(storageKeys.accessToken).then((token) => {
            APIHandler.uploadFile(data, token).then((response) => {
              // Set file url to state
              setFileUrl(response.path);
              const { handleChangeFile } = props;
              handleChangeFile(response.path);
            });
          });
        };

        reader.readAsDataURL(file);
      });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
      accept: {
        'image/jpeg': [],
        'image/png': [],
        'application/pdf': [],
      },
      onDrop,
    });

    return (
      <section className="container">
        <div {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <p>{i18n.translate('rewards.bookingForm.drag')}</p>
          <em>{i18n.translate('rewards.bookingForm.fileType')}</em>
        </div>
      </section>
    );
  };

  const { agentEmail } = props;

  const getUserInfo = useCallback(async () => {
    if (!agentEmail) {
      return;
    }

    const newUser = await APIHandler.getUserRewards(agentEmail);
    if (newUser) {
      setAgentFirstName(newUser.response.first_name);
      setAgentLastName(newUser.response.last_name);
      setAgentCompany(newUser.response.agency_name);
      setPostalCode(newUser.response.zip_code);
      setAgentCity(newUser.response.city);
      setAgentCountry(newUser.response.country);
      setUserInfo(newUser.response);
    }
  }, [agentEmail]);

  const closeIframe = () => {
    setShowIframe(false);

    // Reload user info
    getUserInfo();
  };

  const openFancybox = () => {
    setShowIframe(true);
  };

  useEffect(() => {
    if (Object.keys(userInfo).length === 0) {
      getUserInfo();
    }
  }, [userInfo, getUserInfo]);

  const {
    submitForm,
    handleChange,
    lengthOfStay,
    handleChange1,
    handleChange2,
    routing,
    ticketNumber,
    travelDepartureDate,
    travelReturnDate,
    bookingNumber,
    confirmNumber,
    numberOfTravelers,
  } = props;

  const req = ' *';

  const params = new URLSearchParams(window.location.search);
  let termsUri = '/main/rewards/terms';
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
    termsUri = '/main/rewards/terms?mobile=true';
  }

  // TODO pull from incentives API
  if (agentCountry === 'IE' || agentCountry === 'GB') {
    termsUri = "https://front.travpromobile.com/tc/MegaFam 2024 T_C's .pdf";
  }

  // Pull

  console.log('agentCountry', agentCountry);

  return (
    <div className="contentContainer BookingForm">
      <div className="body">
        <ContentHeader header={i18n.translate('rewards.bookingForm.title')} subtitle="" />

        <hr />

        <form method="post" id="formRewards">
          <h3>{i18n.translate('rewards.bookingForm.subTitle')}</h3>
          <hr className="subline" />

          <div className="grid userInfo">
            {agentEmail}
            <br />
            {agentFirstName} {agentLastName}
            <br />
            {agentCompany}
            <br />
            {agentCity}
            {postalCode && ', '} {postalCode}
            <br />
            {agentCountry}
            <br />
            <button onClick={openFancybox} className="link" type="button">
              {i18n.translate('rewards.bookingForm.edit')}
            </button>
          </div>

          <hr />
          <br />
          <br />
          <h4>{i18n.translate('rewards.bookingForm.sub2')}</h4>
          <p className="required">{i18n.translate('rewards.bookingForm.required')}</p>
          <div className="grid">
            <div className="item medium">
              <label htmlFor="confirmNumber">
                {i18n.translate('rewards.bookingForm.confirmNumber').concat(req)}
                <input
                  name="bookingNumber"
                  value={bookingNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.confirmNumber')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="flightNumber">
                {i18n.translate('rewards.bookingForm.flightNumber').concat(req)}
                <input
                  name="confirmNumber"
                  value={confirmNumber}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.flightNumber')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="travelDepartureDate">
                {i18n.translate('rewards.bookingForm.travelDepartureDate').concat(req)}
                <input
                  name="travelDepartureDate"
                  className="DatePicker"
                  type="date"
                  value={travelDepartureDate}
                  onChange={handleChange2}
                  max={travelReturnDate}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="travelReturnDate">
                {i18n.translate('rewards.bookingForm.travelReturnDate').concat(req)}
                <input
                  name="travelReturnDate"
                  className="DatePicker"
                  type="date"
                  value={travelReturnDate}
                  onChange={handleChange1}
                  min={travelDepartureDate}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="lengthOfStay">
                {i18n.translate('rewards.bookingForm.lengthOfStay').concat(req)}
                <input
                  name="lengthOfStay"
                  value={lengthOfStay}
                  onChange={handleChange}
                  placeholder={i18n.translate('rewards.bookingForm.lengthOfStay')}
                  required
                />
              </label>
            </div>

            <div className="item medium">
              <label htmlFor="numberOfTravelers">
                {i18n.translate('rewards.bookingForm.numberOfTravelers').concat(req)}
              </label>
              <select name="numberOfTravelers" value={numberOfTravelers} onChange={handleChange}>
                <option>{i18n.translate('rewards.bookingForm.select')}</option>
                {Array.from(Array(99), (_, i) => (
                  <option value={i + 1}>{i + 1}</option>
                ))}
                <option value=">99">{'> 99'}</option>
              </select>
            </div>

            {(agentCountry === 'IE' || agentCountry === 'GB') && (
              <div className="item medium">
                <label htmlFor="routing">
                  {'Routing e.g. LHR/IAD/LHR'}
                  <input
                    name="routing"
                    value={routing}
                    onChange={handleChange}
                    placeholder="Routing e.g. LHR/IAD/LHR"
                  />
                </label>
              </div>
            )}

            {(
              ['MX', 'CO', 'BR', 'AR', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'PA', 'UY', 'PR'].includes(agentCountry)
            ) && (
              <div className="item medium">
                <label htmlFor="ticketNumber">
                {i18n.translate('rewards.bookingForm.ticketNumber').concat(req)}
                  <input
                    name="ticketNumber"
                    value={ticketNumber}
                    onChange={handleChange}
                    placeholder= {i18n.translate('rewards.bookingForm.ticketNumber')}
                    required
                  />
                </label>
              </div>
            )}

            <div className="item large" />

            {(
              ['MX', 'CO', 'BR', 'AR', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'PA', 'UY', 'PR'].includes(agentCountry)
            ) && (
              <React.Fragment>
                {fileUrl === null && (
                  <div className="item large">
                    <label htmlFor="file">{i18n.translate('rewards.bookingForm.file').concat(req)}</label>
                    <DropZone />
                  </div>
                )}
                {fileUrl !== null && (
                  <div className="item large success">
                    <label htmlFor="file">{i18n.translate('rewards.bookingForm.file').concat(req)}</label>
                    <div className="file">
                      <div className="fileIcon">
                        <FontAwesomeIcon icon={['fas', 'check-circle']} />
                        <p>{i18n.translate('rewards.bookingForm.fileUploaded')}</p>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}

            {(
              !['MX', 'CO', 'BR', 'AR', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'PA', 'UY', 'PR'].includes(agentCountry)
            ) && (
              <React.Fragment>
                {fileUrl === null && (
                  <div className="item large">
                    <label htmlFor="file">{i18n.translate('rewards.bookingForm.file')}</label>
                    <DropZone />
                  </div>
                )}
                {fileUrl !== null && (
                  <div className="item large success">
                    <label htmlFor="file">{i18n.translate('rewards.bookingForm.file')}</label>
                    <div className="file">
                      <div className="fileIcon">
                        <FontAwesomeIcon icon={['fas', 'check-circle']} />
                        <p>{i18n.translate('rewards.bookingForm.fileUploaded')}</p>
                      </div>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}

          </div>
          <br />
          <hr />
          <div className="buttonHolder">
            <button type="submit" className="btn" onClick={submitForm}>
              {i18n.translate('rewards.bookingForm.button')}
            </button>
            {agentCountry === 'IE' ||
              (agentCountry === 'GB' && (
                <a href={termsUri} data-fancybox="iframe" className="link">
                  {i18n.translate('rewards.TermsAndConditions.title')}
                </a>
              ))}
            {agentCountry !== 'IE' && agentCountry !== 'GB' && (
              <Link to={termsUri}>{i18n.translate('rewards.TermsAndConditions.title')}</Link>
            )}
          </div>
        </form>
      </div>

      {showIframe && (
        <div className="iframe">
          <div
            className="bgIframe"
            onClick={() => {
              closeIframe();
            }}
          />
          <div className="iframeHolder">
            <div
              className="closeIframe"
              href="#"
              onClick={() => {
                closeIframe();
              }}
            >
              <span className="closeText">
                <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {i18n.translate('general.back')}
              </span>
            </div>
            <div className="contentIframe">
              <iframe
                width="100%"
                height="100%"
                id="iframeModal"
                src={`https://accounts.travpromobile.com/profile/?header=false&email=${agentEmail}&app_id=633`}
                title={i18n.translate('rewards.bookingForm.edit')}
              />
            </div>
          </div>
        </div>
      )}

      {mobile && (
        <style>
          {
            '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
          }
        </style>
      )}

      <ToastContainer
        draggablePercent={60}
        autoClose={false}
        newestOnTop
        rtl={false}
        pauseOnVisibilityChange
        draggable
      />
    </div>
  );
};

BookingForm.defaultProps = {
  routing: '',
};

BookingForm.propTypes = {
  submitForm: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChange1: PropTypes.func.isRequired,
  handleChange2: PropTypes.func.isRequired,
  confirmNumber: PropTypes.string.isRequired,
  bookingNumber: PropTypes.string.isRequired,
  lengthOfStay: PropTypes.string.isRequired,
  agentEmail: PropTypes.string.isRequired,
  travelDepartureDate: PropTypes.string.isRequired,
  travelReturnDate: PropTypes.string.isRequired,
  numberOfTravelers: PropTypes.string.isRequired,
  routing: PropTypes.string,
  files: PropTypes.string.isRequired,
};

export default BookingForm;
